"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountProviders = exports.disableDMPsProvider = exports.updateDMPsProvider = exports.fetchConnectedDMPsProvider = exports.fetchDMPsProvider = void 0;
const createApi_1 = require("../../helpers/createApi");
/**
 * @deprecated use getProvidersPull instead
 */
const fetchDMPsProvider = (caller) => ({ accountId }) => {
    return caller(`/accounts/${accountId}/providers`).get();
};
exports.fetchDMPsProvider = fetchDMPsProvider;
/**
 * @deprecated use getProvidersPullEnabled instead
 */
const fetchConnectedDMPsProvider = (caller) => ({ accountId }) => {
    return caller(`/accounts/${accountId}/providers?enabled=true`).get();
};
exports.fetchConnectedDMPsProvider = fetchConnectedDMPsProvider;
const updateDMPsProvider = (caller) => ({ accountId, content }) => {
    return caller(`/accounts/${accountId}/providers`).put(content);
};
exports.updateDMPsProvider = updateDMPsProvider;
const disableDMPsProvider = (caller) => ({ accountId, providerId, instanceId }) => {
    const content = instanceId ? { instance_id: instanceId } : {};
    return caller(`/accounts/${accountId}/providers/${providerId}`).delete(content);
};
exports.disableDMPsProvider = disableDMPsProvider;
const getProvidersPull = (caller) => ({ accountId }) => {
    return caller(`/accounts/${accountId}/providers`).get();
};
const getProvidersPullEnabled = (caller) => ({ accountId }) => {
    return caller(`/accounts/${accountId}/providers?enabled=true`).get();
};
exports.accountProviders = (0, createApi_1.createAPIFactory)({
    /**
     * @deprecated use getProvidersPull instead
     */
    fetchDMPsProvider: exports.fetchDMPsProvider,
    getProvidersPull,
    /**
     * @deprecated use getProvidersPullEnabled instead
     */
    fetchConnectedDMPsProvider: exports.fetchConnectedDMPsProvider,
    getProvidersPullEnabled,
    updateDMPsProvider: exports.updateDMPsProvider,
    disableDMPsProvider: exports.disableDMPsProvider,
});
//# sourceMappingURL=api.js.map